import {Business, EmployeeScale} from "../../domain/model/company";
import {
    BrokerageProjectPossibility,
    FullTimePossibility,
    Gender as CustomerGender,
    Language as CustomerLanguage,
    SpeakingLevel as CustomerSpeakingLevel,
    WorkingFrequency,
    WorkIntention,
} from "../../domain/model/customer";
import {FrontDate} from "../../domain/model/frontDate";
import {Occupation} from "../../domain/model/project";
import {TUpdateJobCareerParams} from "../../domain/repository/job_career_repository";
import {TUpdatePastCaseProjectParams} from "../../domain/repository/past_case_project_repository";
import {entity} from "../../infra/api/rpc/api";

// for Client

interface IUpdatePasswordByClientRequest {
    currentPassword?: string;
    newPassword?: string;
}

class UpdatePasswordByClientRequest implements IUpdatePasswordByClientRequest {
    public currentPassword: string;
    public newPassword: string;
}

interface IUpdateCompanyByClientRequest {
    name?: string;
    logoURL?: string;
    webURL?: string;
    establishedAt?: FrontDate;
    postalCode?: string;
    place?: string;
    business?: Business[];
    representativeName?: string;
    capitalStock?: string;
    employeeScale?: EmployeeScale;
    introduction?: string;
    accordingCompanyName?: string;
    accordingCompanyPostalCode?: string;
    accordingCompanyAddress?: string;
    uploadFileLogoURL?: File | null;
}

class UpdateCompanyByClientRequest implements IUpdateCompanyByClientRequest {
    public name: string;
    public logoURL: string;
    public webURL: string;
    public establishedAt: FrontDate;
    public postalCode: string;
    public place: string;
    public business: Business[];
    public representativeName: string;
    public capitalStock: string;
    public employeeScale: EmployeeScale;
    public introduction: string;
    public accordingCompanyName: string;
    public accordingCompanyPostalCode: string;
    public accordingCompanyAddress: string;
    public invoiceDepartmentName: string;
    public uploadFileLogoURL: File | null;
}

interface IUpdateClientByClientRequest {
    name?: string;
    nameKana?: string;
    iconURL?: string;
    phoneNumber?: string;
    department?: string;
    position?: string;
    uploadFileIconURL?: File | null;
}

class UpdateClientByClientRequest implements IUpdateClientByClientRequest {
    public name: string;
    public nameKana: string;
    public iconURL: string;
    public phoneNumber: string;
    public department: string;
    public position: string;
    public uploadFileIconURL: File | null;
}

interface IUpdateEmailByClientRequest {
    currentPassword?: string;
    email?: string;
}

class UpdateEmailByClientRequest implements IUpdateEmailByClientRequest {
    public currentPassword: string;
    public email: string;
}

// for Customer
interface IGetMeCustomerByCustomerRequest {
}

class GetMeCustomerByCustomerRequest
    implements IGetMeCustomerByCustomerRequest {
}

interface IUpdateCustomerByCustomerRequest {
    name?: string;
    nameKana?: string;
    iconURL?: string;
    birthdate?: FrontDate;
    gender?: CustomerGender;
    phoneNumber?: string;
    pr?: string;
    address?: string;
    academicBackgrounds?: string[];
    requirements?: string[];
    languages?: CustomerLanguage[];
    moreLanguage?: string;
    speakingLevel?: CustomerSpeakingLevel;
    resumeURL?: string;
    jobHistoryURL?: string;
    workingFrequency?: WorkingFrequency;
    requestedFee?: entity.Customer.RequestedFee;
    requestedCondition?: string;
    dutySummary?: string;
    occupations?: Occupation[];
    uploadFileIconURL?: File | null;
    jobCareers?: TUpdateJobCareerParams[];
    pastCaseProjects?: TUpdatePastCaseProjectParams[];
    workIntention?: WorkIntention;
    multiSkillTagIds?: string[];
    facebookURL: string;
    linkedInURL: string;
    xURL: string;
}

class UpdateCustomerByCustomerRequest
    implements IUpdateCustomerByCustomerRequest {
    public name: string;
    public nameKana: string;
    public iconURL: string;
    public birthdate: FrontDate;
    public gender: CustomerGender;
    public phoneNumber: string;
    public pr: string;
    public address: string;
    public academicBackgrounds: string[];
    public requirements: string[];
    public languages: CustomerLanguage[];
    public moreLanguage: string;
    public speakingLevel: CustomerSpeakingLevel;
    public resumeURL: string;
    public jobHistoryURL: string;
    public workingFrequency: WorkingFrequency;
    public requestedFee: entity.Customer.RequestedFee;
    public requestedCondition: string;
    public dutySummary: string;
    public occupations: Occupation[];
    public uploadFileIconURL: File | null;
    public jobCareers: TUpdateJobCareerParams[];
    public pastCaseProjects: TUpdatePastCaseProjectParams[];
    public workIntention: WorkIntention;
    public fullTimePossibility: FullTimePossibility;
    public brokerageProjectPossibility: BrokerageProjectPossibility;
    public portfolio: string;
    public multiSkillTagIds: string[];
    public birthplace: string;
    public facebookURL: string;
    public linkedInURL: string;
    public xURL: string;
}

interface IUpdatePasswordByCustomerRequest {
    currentPassword?: string;
    newPassword?: string;
}

class UpdatePasswordByCustomerRequest
    implements IUpdatePasswordByCustomerRequest {
    public currentPassword: string;
    public newPassword: string;
}

interface IUpdateEmailByCustomerRequest {
    currentPassword?: string;
    email?: string;
}

class UpdateEmailByCustomerRequest implements IUpdateEmailByCustomerRequest {
    public currentPassword: string;
    public email: string;
}

interface IGenerateCustomerPDFByCustomerRequest {
}

class GenerateCustomerPDFByCustomerRequest
    implements IGenerateCustomerPDFByCustomerRequest {
}

interface IDestroyCustomerPDFByCustomerRequest {
}

class DestroyCustomerPDFByCustomerRequest
    implements IDestroyCustomerPDFByCustomerRequest {
}

export {
    DestroyCustomerPDFByCustomerRequest,
    GenerateCustomerPDFByCustomerRequest,
    // customer mypage
    GetMeCustomerByCustomerRequest,
    UpdateClientByClientRequest,
    UpdateCompanyByClientRequest,
    UpdateCustomerByCustomerRequest,
    UpdateEmailByClientRequest,
    UpdateEmailByCustomerRequest,
    UpdatePasswordByClientRequest,
    UpdatePasswordByCustomerRequest,
};



// WEBPACK FOOTER //
// ./src/presentation/request/mypage_request.ts